import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { WhoWeAre } from './components/WhoWeAre';
import { About } from './components/About';
import { Sectors } from './components/Sectors';
import { Services } from './components/Services';
import { Clients } from './components/Clients';
import { Stats } from './components/Stats';
import { InstagramFeed } from './components/InstagramFeed';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
import { WhatsAppButton } from './components/WhatsAppButton';
export function App() {
  return <div className="min-h-screen w-full bg-vm-bg font-inter text-white" data-id="element-0" data-mp="31bs1ff0jszn8">
      <Navbar data-id="element-1" data-mp="2wk9y4kb1ymz3" />
      <main data-id="element-2" data-mp="2wjqg73lejyl2">
        <Hero data-id="element-3" data-mp="2wj8cxn0bok3n" />
        <WhoWeAre data-id="element-4" data-mp="2wifhhi6tdh0t" />
        <About data-id="element-5" data-mp="2whxcnx635uha" />
        <Stats data-id="element-6" data-mp="28ufoscpxzgjl" />
        <Sectors data-id="element-7" data-mp="28tw4wqgqei2x" />
        <Services data-id="element-8" data-mp="28te2td7e19n3" />
        <Clients data-id="element-9" data-mp="28suvsrja05nu" />
        <InstagramFeed data-id="element-10" data-mp="28sb9kymlev40" />
        <Contact data-id="element-11" data-mp="23vkw8j26adma" />
      </main>
      <Footer data-id="element-12" data-mp="23u9ueosaffxt" />
      <WhatsAppButton data-id="element-13" data-mp="23utcc5hxu4bu" />
    </div>;
}